<template>
<div
    class="skill card flex items-center justify-center m-2"
    :class="{ skill__locked: !trophy.unlocked }"
>
    <div class="content"
    :class="{
        'text-center': trophy.icon === undefined
    }">
        <img :src="trophy.icon.url" alt="" v-if="trophy.icon !== undefined"/>
        <p v-html="trophy.text.replace(/\n/g, '<br />')" />
    </div>
</div>
</template>

<script>
export default {
    props: {
        trophy: {
            type: Object,
            required: true
        }
    }
}
</script>